var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.fixedScroll,
      expression: "fixedScroll"
    }],
    staticClass: "header header--fixed header--menu-all"
  }, [_c('div', {
    staticClass: "header__body"
  }, [_c('v-container', [_c('h1', {
    staticClass: "header__logo"
  }, [_c('a', {
    attrs: {
      "href": "/en",
      "title": "home"
    }
  }, [_c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v("IST")])])]), _c('div', {
    staticClass: "header__contents"
  }, [_c('div', {
    staticClass: "header__gnb justify-center"
  }, [_c('client-gnb', {
    attrs: {
      "className": "gnb"
    }
  })], 1), _c('div', {
    staticClass: "header__right"
  }, [_c('div', {
    staticClass: "lang"
  }, [_c('p', {
    staticClass: "lang_li d-none d-xl-flex"
  }, [_vm._v("EN")]), _c('a', {
    staticClass: "lang_li",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("KR")])])])])])], 1), _vm._m(0), _c('div', {
    staticClass: "header__bg"
  })]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hamburger-btn"
  }, [_c('span')]);
}]

export { render, staticRenderFns }